import { render, staticRenderFns } from "./divisionrulemanagement.vue?vue&type=template&id=8840717a&scoped=true"
import script from "./divisionrulemanagement.vue?vue&type=script&lang=js"
export * from "./divisionrulemanagement.vue?vue&type=script&lang=js"
import style0 from "./divisionrulemanagement.vue?vue&type=style&index=0&id=8840717a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8840717a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8840717a')) {
      api.createRecord('8840717a', component.options)
    } else {
      api.reload('8840717a', component.options)
    }
    module.hot.accept("./divisionrulemanagement.vue?vue&type=template&id=8840717a&scoped=true", function () {
      api.rerender('8840717a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commissionmanagement/divisionrulemanagement.vue"
export default component.exports